<form [formGroup]="form" (ngSubmit)="accept()">
    <h1 mat-dialog-title>Exportaciones</h1>
    <div mat-dialog-content>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-label *ngIf="!loading && billingExportTypeFilters.length === 0">No hay configuradas exportaciones para la entidad</mat-label>
        <mat-form-field *ngIf="!loading && billingExportTypeFilters.length > 0" class="full-width">
            <mat-select placeholder="Exportaciones" formControlName="billingExportType">
                <mat-option *ngFor="let billingExportType of billingExportTypeFilters" [value]="billingExportType"> {{ billingExportType.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.billingExportType.errors && f.billingExportType.errors.required">
                Seleccione un tipo de exportación
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div *ngIf="!loading" class="pull-right">
            <button *ngIf="billingExportTypeFilters.length > 0" mat-button type="submit">Aceptar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>